export const ASYNC_FETCH = 'ITP_Landing/ASYNC_FETCH';
export const ASYNC_FETCH_LANDING_SUCCESS = 'ITP_Landing/ASYNC_FETCH_LANDING_SUCCESS';
export const ASYNC_FETCH_FAILURE = 'ITP_Landing/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ITP_Landing/ASYNC_FETCH_INVALIDATE';
export const ASYNC_FETCH_LANDINGCQ_SUCCESS='ITP_Landing/ASYNC_FETCH_LANDINGCQ_SUCCESS';
/**
 * action types
 * @type {string}
 */
export const formatPhoneNumber = (val) => { // eslint-disable-line
  if (val !== '') {
    return val.substring(0, 3) + '.' + val.substring(3, 6) + '.' + val.substring(6);
  }
  return val;
};
